import React, { useEffect, useState } from 'react'
import LinearProgress from '@mui/material/LinearProgress'
import useAuth from '../../../../hooks/useAuth'
import IssueApi from '../../../../api/IssueApi'
import { FormIssueEntity } from './AdminIssueForm'
import { IssueForm } from './IssueForm'

const issueApi = new IssueApi()

export function EditIssueForm({
    issueId,
    onChangeIssue,
}: {
    issueId: string
    onChangeIssue: (issue: FormIssueEntity) => void
}) {
    const { isAuthenticated } = useAuth()
    const [issue, setIssue] = useState<FormIssueEntity | null>(null)
    async function fetchData() {
        if (!isAuthenticated || !issueId) return
        const result = await issueApi.findByIssueId(issueId, false)

        if (result) {
            setIssue(result)
            onChangeIssue(result)
        }
    }
    useEffect(() => {
        void fetchData()
    }, [issueId, isAuthenticated, onChangeIssue])

    if (!issue) return <LinearProgress />
    return <IssueForm issue={issue} reFetchData={fetchData} />
}
